import { TeacherCertificationDialogComponent } from '../components/user/sections/user-agreements-data/teacher-certification-dialog/teacher-certification-dialog.component';
import { TeacherCertification } from '../models/management/teacher-certification.model';
import { BaseComponentService } from './_app/base-component.service';
import { ApiResponse } from '../models/api/api-response.model';
import { ApiError } from '../models/api/api-error.model';
import { catchError, map, throwError } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API } from '../constants/api';

@Injectable({ providedIn: 'root' })
export class TeacherCertificationService {
  private _baseComponentService = inject(BaseComponentService);
  private _http: HttpClient = inject(HttpClient);

  private _getCertificationDetails(url: string) {
    return this._http
      .get<ApiResponse<TeacherCertification>>(url, { withCredentials: true })
      .pipe(
        catchError((error) => throwError(() => new ApiError(error))),
        map((response) => {
          response.data = new TeacherCertification(response.data);
          return response;
        })
      );
  }

  // Cerca i dettagli della certificazione dall'ID del docente
  getTeacherCertification(teacherId?: string) {
    return this._getCertificationDetails(API.teacherCertification(teacherId));
  }

  // Cerca i dettagli della certificazione dall'ID
  getTeacherCertificationDetails(teacherCertificationId?: string) {
    return this._getCertificationDetails(
      API.teacherCertificationDetails(teacherCertificationId)
    );
  }

  postTeacherCertification(data: any) {
    return this._http
      .post<ApiResponse<TeacherCertification>>(
        API.teacherCertification(),
        data,
        { withCredentials: true }
      )
      .pipe(
        catchError((error) => throwError(() => new ApiError(error))),
        map((response) => {
          response.data = new TeacherCertification(response.data);
          return response;
        })
      );
  }

  patchTeacherCertification(id: string, data: any) {
    return this._http
      .patch<ApiResponse<TeacherCertification>>(
        API.teacherCertificationDetails(id),
        data,
        { withCredentials: true }
      )
      .pipe(
        catchError((error) => throwError(() => new ApiError(error))),
        map((response) => {
          response.data = new TeacherCertification(response.data);
          return response;
        })
      );
  }

  deleteTeacherCertificationAttachment(tc?: TeacherCertification) {
    return this._http
      .delete<ApiResponse<any>>(
        API.teacherCertificationAttachment(tc?.id, tc?.attachment),
        { withCredentials: true }
      )
      .pipe(
        catchError((error) => throwError(() => new ApiError(error))),
        map((response) => {
          return response;
        })
      );
  }

  deleteTeacherCertification(id?: string) {
    return this._http
      .delete<ApiResponse<any>>(API.teacherCertificationDetails(id), {
        withCredentials: true,
      })
      .pipe(
        catchError((error) => throwError(() => new ApiError(error))),
        map((response) => {
          return response;
        })
      );
  }

  // Dialog
  openTeacherCertificationDialog(data?: any) {
    const dialogSize = '700px';
    return this._baseComponentService.dialog.open(
      TeacherCertificationDialogComponent,
      {
        maxWidth: dialogSize,
        minWidth: dialogSize,
        restoreFocus: false,
        autoFocus: false,
        data,
      }
    );
  }
}
